import { MapLayer } from "@iventis/domain-model/model/mapLayer";
import { useQueryClient } from "@tanstack/react-query";
import { LAYER_THUMBNAIL_KEY } from "../sidebar-library/sidebar-nodes";
import { getLayerThumbnailAssets } from "../state/map.slice.functions";

/** Returns a function which will get a layer's thumbnail url */
export function useGetLayerThumbnailPreview() {
    const queryClient = useQueryClient();

    const getMapLayerPreviewUrl = async (layer: MapLayer) => {
        // Check if the thumbnail url is already in the cache
        const layerPreviewUrl = queryClient.getQueryData<string>([LAYER_THUMBNAIL_KEY, layer.id]);
        if (layerPreviewUrl != null) {
            return layerPreviewUrl;
        }
        // Else fetch the thumbnail url
        const res = await getLayerThumbnailAssets([layer]);
        const thumbnailUrl = res?.length ? res[0]?.assetUrl : null;
        if (thumbnailUrl) {
            queryClient.setQueryData([LAYER_THUMBNAIL_KEY, layer.id], thumbnailUrl);
        }
        return thumbnailUrl;
    };

    return getMapLayerPreviewUrl;
}
